import React from 'react'
function Meter(props) {
  let {value} = props
  return (<section className="navbar-center">
    <meter className="meter" value={value} optimum="90" min="0" max="100" low="40" high="70" style={{
        width: "42rem"
      }}></meter>
  </section>)

}

export default Meter



// WEBPACK FOOTER //
// ./src/topModule/Meter.js